module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Normal.a4c3cd99.ttf";